
import SearchComponent from "./index.vue";
import {PropType} from 'vue';
import {Page} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Page';
import PageSearchService from 'modules/spravochnik/dt-front-page-generator/src/Search/PageSearchService';

export default {
    components: {
        SearchComponent,
    },
    emits: [
        'openSearch'
    ],
    props: {
        pages: {
            type: Array as PropType<Array<Page>>,
        },
        placeholder: {
            type: String,
        },
    },
    data() {
        return {
            service: new PageSearchService(),
        }
    }
}
